import {
  Card,
  Form,
  Input,
  Select,
  Button,
  Tooltip,
  Space,
  Switch,
  Row,
  Col,
  InputNumber,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

export default function ComplianceContent({
  form,
  onNext,
  onPrevious,
  interbankTemplate,
  currency,
}) {
  const [amlScreening, setAmlScreening] = useState(false);

  const handleInputChange = (field, value) => {
    form.setFieldValue(field, value);
  };

  const CurrencyObj = interbankTemplate.currencies.filter(
    (Item) => Item.code === currency
  );

  useEffect(() => {
    const initialAmlScreening =
      form.getFieldValue("mandatoryAMLScreening") || false;

    setAmlScreening(initialAmlScreening);
  }, [form]);

  const handleAmlScreeningChange = (checked) => {
    setAmlScreening(checked);
    handleInputChange("mandatoryAMLScreening", checked);
  };

  const handleNext = async () => {
    try {
      await form.validateFields([
        "centralBankReports",
        "riskLimit",
        "mandatoryAMLScreening",
      ]);
      onNext();
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  return (
    <Card
      style={{
        borderRadius: "12px",
        boxShadow:
          "0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          marginBottom: "32px",
        }}
      >
        <h1
          style={{
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "32px",
            color: "#101828",
            marginBottom: "0px",
          }}
        >
          Compliance
        </h1>
        <p
          style={{
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#344054",
            marginTop: "0px",
          }}
        >
          Define Compliance Parameters
        </p>
      </div>

      <Form layout="vertical" requiredMark={false} form={form}>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Central Bank Reporting
                  <Tooltip title="Central bank reporting information">
                    <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                  </Tooltip>
                </Space>
              }
              name="centralBankReports"
              rules={[
                {
                  required: false,
                  message: "Please select central bank reporting",
                },
              ]}
              validateTrigger={["onChange", "onBlur"]}
            >
              <Select
                placeholder="Select central bank reporting"
                mode="multiple"
                style={{ width: "100%" }}
                onChange={(value) =>
                  handleInputChange("centralBankReports", value)
                }
                options={interbankTemplate?.centralBankReportOptions?.map(
                  (option) => ({
                    value: option.id,
                    label: option.name,
                  })
                )}
              />
            </Form.Item>

            <Form.Item
              label={
                <Space>
                  Risk Limits
                  <Tooltip title="Risk limits information">
                    <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                  </Tooltip>
                </Space>
              }
              name="riskLimit"
              rules={[
                { required: true, message: "Please enter risk limit" },
                {
                  pattern: /^\d*\.?\d*$/,
                  message: "Please enter a valid number",
                },
              ]}
              validateTrigger={["onChange", "onBlur"]}
            >
              <InputNumber
                prefix={CurrencyObj[0].code}
                placeholder="0.00"
                style={{ width: "100%", height: "44px" }}
                onChange={(value) => handleInputChange("riskLimit", value)}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                min={0}
                step={0.01}
                parser={(value) => (value ? value.replace(/(,*)/g, "") : "")}
              />
            </Form.Item>
            <Form.Item
              name="mandatoryAMLScreening"
              style={{ marginBottom: 16 }}
              // valuePropName="checked"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <Switch
                  size="large"
                  style={{ backgroundColor: undefined }}
                  checked={amlScreening}
                  onChange={handleAmlScreeningChange}
                />
                <Space>AML Screening</Space>
              </div>
            </Form.Item>
          </Col>
        </Row>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "32px",
            gap: "12px",
          }}
        >
          <Button style={{ height: "44px" }} onClick={onPrevious}>
            Previous
          </Button>
          <Button
            type="primary"
            style={{ backgroundColor: "#9F1AB1", height: "44px" }}
            onClick={handleNext}
          >
            Next - Preview
          </Button>
        </div>
      </Form>
    </Card>
  );
}
